<app-popup-model [title]="title" (close)="signout()" [saveButton]="saveButtonText" (save)="close()"
  [isDisableSaveButton]="disableSaveButton" [removeCloseButton]="false">
  <div>
    <div class="consent-container">
      <form [formGroup]="form" (ngSubmit)="close()" novalidate class="enforce-password-change-form">
        <div class="enforce-password-change-field">
          <label for="oldPass">Old Password*</label>
          <input type="password" formControlName="oldPass" class="loginFeilds" placeholder="Old Password*"
            autocomplete="off" />
          <div class="error" *ngIf="form.get('oldPass')?.touched && form.get('oldPass').hasError('required')">
            This is required
          </div>
        </div>

        <div class="enforce-password-change-field">
          <label for="oldPass">New Password*</label>

          <input type="password" formControlName="newPass" class="loginFeilds" placeholder="New Password*"
            autocomplete="off" />
          <div class="error" *ngIf="form.get('newPass')?.touched && form.get('newPass').hasError('required')">
            This is required.
          </div>
          <div class="error" *ngIf="form.get('newPass')?.touched && form.get('newPass').hasError('pattern')">
            Password must be at least 14 characters long and include uppercase and lowercase letters, a number, and
            a special character.
          </div>
        </div>

        <div class="enforce-password-change-field">
          <label for="oldPass">Confirm New Password*</label>
          <input type="password" formControlName="confirmPass" class="loginFeilds" placeholder="Confirm New Password*"
            autocomplete="off" />
          <div class="error" *ngIf="confirmPassError">{{ confirmPassError }}</div>
          <div class="error" *ngIf="form.get('confirmPass')?.touched && form.get('confirmPass').hasError('required')">
            This is required.
          </div>
          <div class="error" *ngIf="form.get('confirmPass')?.touched && form.get('confirmPass').hasError('mismatch')">
            Passwords do not match.
          </div>
        </div>
      </form>

      <span *ngIf="error && !isPasswordChangedSuccessfully" style="color: red; display: flex;
    justify-content: center;">{{error.error }}</span>
      <span *ngIf="isPasswordChangedSuccessfully" style="color: green;">Your Password has been changed Successfully!! <br>
      Please click "OK" to login with your new password</span> 
    </div>
  </div>
</app-popup-model>